import React from 'react'
import Main from '../../../components/HOC/Main'

export default function ConfigurationPage() {
  return (
    <Main crumbs={[{ title: "setting" }, { title: "configurations" }]}>
        <div>This page is under development. Will be available soon !!</div>
    </Main>
  )
}
